// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9446774c","455":"e7085e7f","977":"4e611b97"}[chunkId] + ".chunk.js";
};